import {
    useBooleanABTestOrCookie,
    useFlagOrCookie,
} from "@khan/analytics-growthbook";
import {RequestInfo} from "@khan/shared-core";

const FEATURE_FLAG_NAME = "new-registration-flow";
const TOS_CHECKBOX_FLAG_NAME = "signup-tos-checkbox-required";
/**
 * Determines if the user is in an A/B test or not. This also supports using
 * the query param ?flags_on=new-registration-flow to force the new experience
 * to display.
 * - If true, you're in the experiment.
 * - If false, you're not in the experiment.
 * - If null, we don't know yet, hold off on rendering so you don't have a FOUC,
 * or show the default experience.
 *
 * Note: current rules are that the user must be en-US or en-CA, if TOS flag is not enabled.
 */
export function useNewRegistrationFlowFeature(): boolean | null {
    // Call both hooks unconditionally
    const tosCheckboxFlag = useFlagOrCookie(TOS_CHECKBOX_FLAG_NAME);
    const abTestFlag = useBooleanABTestOrCookie(
        FEATURE_FLAG_NAME,
        !(
            RequestInfo.kaLocale === "en" &&
            (RequestInfo.remoteCountry === "US" ||
                RequestInfo.remoteCountry === "CA")
        ),
    );

    // if TOS flag is enabled, skip locale checks
    if (tosCheckboxFlag) {
        return true;
    }

    return abTestFlag;
}
